import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const REPORT_NEO = '/ReportNeo'

const reportNeoApiLegacy = makeGetCsv(REPORT_NEO)

async function downloadReportNeo() {
  const apiClient = getApiClient()
  return reportNeoApiLegacy(apiClient)
}

export function useReportNeoExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadReportNeo,
  })

  return [mutateAsync, isPending]
}

